import styled from 'styled-components';

export const LoadingOverlay = styled.span`
    position: absolute;
    inset: 0;

    place-content: center;
    z-index: 1;
    background-color: var(--cds-color-insensitive-background);
    border-radius: inherit;
`;
